import Vue from 'vue'

import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import numberPad from 'vux/src/tools/number/pad.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

Vue.use(DatetimePlugin)
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(WechatPlugin)
Vue.use(AjaxPlugin)

Vue.prototype.$alert = function (content,title) {
let _title = '操作结果'
if(title){
_title =title
}
return new Promise((resolve, reject) => {
Vue.$vux.alert.show({
title: _title,
content: content,
onHide () {
resolve()
}
})
})
}
Vue.prototype.$loading = function (text) {
let _text = ''
if(text){
_text = text
}
Vue.$vux.loading.show({
text: _text
})
}

Vue.prototype.$toast = function (config) {
let _config={
text:'错误',
type:'text',
width:'7.6em'
}
Object.assign(_config, config)
Vue.$vux.toast.show(_config)
}

Vue.prototype.$regValidate = function (config) {
let result = false
switch(config.type){
case 'mobile':
if(config.text.length != 11){
break;
}else{
let reg=/^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(17[0-9]{1}))+\d{8})$/
result = reg.test(config.text)
break;
}

case 'idcard':
if(config.text.length == 18){
let reg=/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
result = reg.test(config.text)
break;
}
else if(config.text.length == 15){
let reg=/^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/
result = reg.test(config.text)
break;
}
}
return result
}

Vue.prototype.$numberPad = value=>{
return numberPad(value,2)
}

Vue.prototype.$guid = function () {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8)
return v.toString(16)
})
}




// WEBPACK FOOTER //
// ./src/assets/js/utils/plugin.js